import {
  type CreateTenantDto,
  createTenant,
  deleteTenant,
  listTenants,
  type TenantDto,
} from '@avila-roffe/api-clients-admin-bff';
import { toast } from '@avila-roffe/components-web';
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { unwrap } from '../lib/api';

export const tenantKeys = {
  all: ['tenants'] as const,
  lists: (params?: object) => [...tenantKeys.all, 'list', params ?? {}] as const,
  detail: (slug: string) => [...tenantKeys.all, 'detail', slug] as const,
};

export function useTenants({ limit = 20, offset = 0 }: { limit?: number; offset?: number } = {}) {
  return useQuery({
    queryKey: tenantKeys.lists({ limit, offset }),
    queryFn: async () => {
      const res = await listTenants({ limit, offset });
      return unwrap<{ items: TenantDto[]; total: number }>(res);
    },
    placeholderData: keepPreviousData,
  });
}

export function useCreateTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateTenantDto) => createTenant(dto),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: tenantKeys.lists() });
      toast.success('Tenant created');
    },
  });
}

export function useDeleteTenant() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (slug: string) => deleteTenant(slug),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: tenantKeys.lists() });
      toast.success('Tenant deleted');
    },
  });
}
